/** @format */

import {Link as RouterLink, useLocation} from 'react-router-dom';
import GetAppIcon from '@mui/icons-material/GetApp';
import {Trans} from 'react-i18next';

import {styled} from '@mui/material/styles';

import {People} from 'mixpanel-browser';

import SecondaryMediumButton from 'components/buttons/SecondaryMediumButton';
import {useMixpanelContext} from 'contexts/MixpanelContext';

const StyledSecondaryMediumButton = styled(SecondaryMediumButton)(({theme}) => ({
  padding: theme.spacing(4, 8),
  borderRadius: theme.spacing(2),
  background: '#202020',
  boxShadow: '1px 1px 5px 0px rgba(0, 0, 0, 0.05)',
  color: '#F1F1F1',
  fontSize: '14px',
  fontWeight: 400,
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    marginTop: theme.spacing(4),
  },
  '&:hover': {
    background: '#202020',
  },
}));

interface ReportButtonProps {
  sensors: string[];
}

const ReportButton = ({sensors}: ReportButtonProps) => {
  const {mixpanel} = useMixpanelContext();
  const fixedMixpanel = mixpanel as typeof mixpanel & {people: People};
  const location = useLocation();

  const handleClickDownload = () => {
    fixedMixpanel.people.increment('open_partial_report_page_count');
    mixpanel.track('open_partial_report_page', {sensors: sensors.join(',')});
  };

  return (
    <RouterLink
      data-testid='report-button'
      to={`/home/main/report?sensors=${sensors.join(',')}`}
      state={{background: location}}
      style={{textDecoration: 'none'}}
    >
      <StyledSecondaryMediumButton onClick={handleClickDownload}>
        <GetAppIcon fontSize='small' htmlColor='#fff' />
        <Trans>Отчет</Trans>
      </StyledSecondaryMediumButton>
    </RouterLink>
  );
};

export {ReportButton};
